export default "__VITE_ASSET__7a4de082__"